import Button from "@mui/material/Button";
import MuiDialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import React from "react";
import { DialogProps as MuiDialogProps } from "@mui/material/Dialog";

interface DialogProps extends Omit<MuiDialogProps, "maxWidth"> {
  onClose: () => void;
  children: React.ReactNode;
  closeText?: string;
  closeAlignment?: "left" | "right";
  showClose?: boolean;
  backgroundColor?: string;
  minHeight?: number | string;
  maxWidth?: number | string;
  buttonSx?: any;
}

const Dialog: React.FC<DialogProps> = ({
  open,
  onClose,
  children,
  showClose = true,
  closeText = "Close",
  closeAlignment = "right",
  buttonSx = {},
  backgroundColor = "#ffffff",
  minHeight = 350,
  maxWidth = 320,
  ...rest
}) => {
  return (
    <MuiDialog
      {...rest}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: 4,
          backgroundColor,
          maxWidth: maxWidth,
          minHeight: minHeight,
        },
      }}
      open={open}
      onClose={onClose}
    >
      <DialogContent>{children}</DialogContent>
      {showClose && (
        <DialogActions sx={{ justifyContent: closeAlignment }}>
          <Button
            onClick={onClose}
            sx={{ fontWeight: "medium", ...buttonSx }}
            color={"primary"}
          >
            {closeText}
          </Button>
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default Dialog;
